import axios from 'axios'
const CurrentApi = {
    async fetchSong(payload) {
       const song = await axios.post("/api/_song/", payload)
       return song
    }
}

export default CurrentApi